import { GoogleTagManagerSetting } from 'backend';
import {
  getGtmDataLayerName,
  getGtmLoadScriptElementId,
  insertDataLayers,
} from '../models';

type GetInitializeScriptPayload = {
  containerId: string;
  dataLayerName: string;
};

const getInitializeScript = ({
  containerId,
  dataLayerName,
}: GetInitializeScriptPayload) => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','${dataLayerName}','${containerId}');
`;

type InitializeGtmPayload = Pick<
  GoogleTagManagerSetting,
  'containerId' | 'dataLayers'
>;

export const initializeGtm = ({
  containerId,
  dataLayers,
}: InitializeGtmPayload): void => {
  const scriptId = getGtmLoadScriptElementId(containerId);
  const dataLayerName = getGtmDataLayerName();

  insertDataLayers(dataLayerName, dataLayers);

  const initializeScript = getInitializeScript({
    containerId,
    dataLayerName,
  });
  const initializeScriptElement = document.createElement('script');
  initializeScriptElement.id = scriptId;
  initializeScriptElement.text = initializeScript;
  document.body.appendChild(initializeScriptElement);
};
